import Modal from 'react-modal';

const defaultActionButtonStyle = {
    border: 'none',
    borderRadius: 6,
    background: '#153243',
    color: '#fff',
    fontSize: 12,
    fontWeight: 600,
    padding: '6px 10px',
    cursor: 'pointer',
};

export default function AssignApproverModal({
    isOpen,
    invoiceID,
    title = 'Assign Approver',
    description,
    selectedApproverEmail,
    onApproverChange,
    availableApprovers = [],
    onCancel,
    onAssign,
    isAssigning = false,
    isApproversLoading = false,
    cancelButtonClassName,
    assignButtonClassName,
    cancelButtonStyle,
    assignButtonStyle,
    cancelLabel = 'Cancel',
    confirmLabel = 'Assign',
    loadingLabel = 'Assigning...',
}) {
    const isAssignDisabled = isAssigning || isApproversLoading;
    const resolvedCancelButtonStyle = cancelButtonStyle || (cancelButtonClassName ? undefined : defaultActionButtonStyle);
    const resolvedAssignButtonStyle = assignButtonStyle || (assignButtonClassName ? undefined : defaultActionButtonStyle);
    const modalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'var(--theme-bg-elevated)',
            color: 'var(--theme-text)',
            minWidth: '360px',
            borderRadius: '10px',
            border: '1px solid rgba(21, 50, 67, 0.24)',
            padding: '18px',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
            zIndex: 1000,
        },
    };

    return (
        <Modal
            isOpen={Boolean(isOpen)}
            onRequestClose={onCancel}
            style={modalStyles}
            contentLabel={title}
        >
            <h3 style={{ marginTop: 0, marginBottom: 10 }}>{title}</h3>
            <p style={{ marginTop: 0, marginBottom: 12 }}>
                Invoice #{invoiceID || ''}
            </p>
            {description ? (
                <p style={{ marginTop: 0, marginBottom: 12, lineHeight: 1.4 }}>
                    {description}
                </p>
            ) : null}
            <select
                value={selectedApproverEmail || ''}
                onChange={(event) => onApproverChange?.(event.target.value)}
                style={{ width: '100%', marginBottom: 14, padding: '8px' }}
            >
                <option value="">Select an in-office approver</option>
                {availableApprovers.map((approver) => (
                    <option key={approver.approverEmail} value={approver.approverEmail}>
                        {approver.approverEmail} (Tier {approver.tierNumber})
                    </option>
                ))}
            </select>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button
                    className={cancelButtonClassName}
                    onClick={onCancel}
                    type="button"
                    style={resolvedCancelButtonStyle}
                >
                    {cancelLabel}
                </button>
                <button
                    className={assignButtonClassName}
                    onClick={onAssign}
                    disabled={isAssignDisabled}
                    type="button"
                    style={{
                        ...(resolvedAssignButtonStyle || {}),
                        opacity: isAssignDisabled ? 0.7 : 1,
                    }}
                >
                    {isAssigning ? loadingLabel : confirmLabel}
                </button>
            </div>
        </Modal>
    );
}
